import { useState, useEffect, useRef } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
    IconAdd,
    IconArrow,
    IconDetails,
    IconEdit,
    IconFilter,
    IconRemove,
} from "../../components/layout/Svgs";

import {
    HeaderPonto,
    SectionFilterPonto,
    SectionTablePonto,
    SectionDetailsPonto,
    SectionRegisterPonto,
    ContainerPonto,
    Value,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";
import Paginate from "../../components/paginate/Paginate";
import CommentBox from "../../components/CommentBox";
import CommentBoxSaida from "../../components/CommentBoxSaida";

export default function SaidasRelatorio() {
    const [load, setLoad] = useState(false);
    const [modal, setModal] = useState(false);
    const [de, setDe] = useState(moment().startOf("year"));
    const [ate, setAte] = useState(moment().endOf("year"));

    const [replicacao, setReplicacao]: any = useState(null);

    const [selectedFile, setSelectedFile]: any = useState(null);
    const fileInputRef: any = useRef(null);

    const [saidas, setSaidas]: any = useState({});
    const [page, setPage] = useState<any>(1);
    const [newSaida, setNewSaida] = useState({
        saidaId: null,
        colaboradorId: null,
        despesaId: null,
        contaId: null,
        valor: "",
        arquivo: "",
        data: moment().format("YYYY-MM-DD"),
        dataPagamento: moment().format("YYYY-MM-DD"),
        statusPagamento: "pendente",
        status: "ativo",
    });

    const [despesas, setDespesas] = useState([]);
    const [colaboradores, setColaboradores] = useState([]);
    const [tiposPagamentos, setTiposPagamentos] = useState([]);
    const [contas, setContas] = useState([]);

    useEffect(() => {
        getSaidas();
        getDespesas();
        getColaboradores();
        getTiposPagamento();
        getContas();

        if (selectedFile) {
            handleUpload();
        }
    }, [selectedFile, page]);

    const handleFileChange = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        // Atualiza o estado com o arquivo selecionado
        await setSelectedFile(event.target.files && event.target.files[0]);
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
    };

    const handleUpload = async () => {
        // Verifica se um arquivo foi selecionado
        if (!selectedFile) {
            console.log("Nenhum arquivo selecionado");
            return;
        }

        // Cria um objeto FormData para envolver o arquivo
        const formData = new FormData();
        formData.append("file", selectedFile);

        // Adiciona os headers necessários
        const headers = {
            Authorization:
                "eyJhbGciOiJIUzI1NiJ9.Z3VpbGhlcm1lQHRyb3BhLmRpZ2l0YWx8fDIwMjQtMDEtMzBUMTc6NDE6MjQuNDIzWg.kOgosOkVSVyj05bqirzFLA29o7b8wYbIC9GKz-HDI0Q",
            Destination: "tropafinanceiro",
        };

        try {
            // Envia a solicitação usando o Axios
            const response = await axios.post(
                "https://bucket.backendtropa.com.br/upload",
                formData,
                {
                    headers,
                }
            );

            setNewSaida({
                ...newSaida,
                arquivo: response?.data?.arquivo,
            });
            // Limpa o estado para permitir novos uploads
            //setSelectedFile(null);
        } catch (error) {
            console.error("Erro no upload:", error);
        }
    };

    const handleChooseFile = () => {
        // Aciona o clique no input file quando o botão personalizado é clicado
        if (fileInputRef?.current) {
            fileInputRef?.current!.click();
        }
    };

    async function getSaidas() {
        try {
            let response: any = await api.get(
                `/saida/relatorio?de=${de}&ate=${ate}`
            );
            console.log(response.data);

            setSaidas(response.data);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function getColaboradores() {
        try {
            let response: any = await api.get(`/colaborador`);
            setColaboradores(response.data);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function getDespesas() {
        try {
            let response: any = await api.get(`/despesa`);
            setDespesas(response.data);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function getTiposPagamento() {
        try {
            let response: any = await api.get(`/tipo-pagamento`);
            setTiposPagamentos(response.data);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function getContas() {
        try {
            let response: any = await api.get(`/conta`);
            setContas(response.data);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function resetSaida() {
        setNewSaida({
            saidaId: null,
            colaboradorId: null,
            despesaId: null,
            contaId: null,
            valor: "",
            arquivo: "",
            data: moment().format("YYYY-MM-DD"),
            dataPagamento: moment().format("YYYY-MM-DD"),
            statusPagamento: "pendente",
            status: "ativo",
        });

        setModal(false);
    }

    function handleOnChangeReplicacao(name: string, value: string) {
        console.log(value);
        setReplicacao(value);
    }

    function handleOnChangeNewSaida(name: string, value: string) {
        if (value) {
            setNewSaida({ ...newSaida, [name]: value });
        } else {
            setNewSaida({ ...newSaida, [name]: "" });
        }
    }

    const handleChange = (value: any) => {
        // Atualiza o estado com o novo valor da entrada
        setNewSaida({ ...newSaida, valor: value });
    };

    async function editarSaida(id?: any) {
        try {
            if (id) {
                let response = await api.get(`/saida/${id}`);

                if (response.data.valor) {
                    response.data.valor = parseFloat(
                        response.data.valor
                    ).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    });
                }

                setNewSaida(response.data);
            } else {
                resetSaida();
            }

            setModal(true);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function saveSaida(e: any) {
        try {
            e.preventDefault();
            let response: any;
            if (newSaida.saidaId) {
                response = await api.put(
                    `/saida/${newSaida.saidaId}`,
                    newSaida
                );
                message.success(`Saida Editada com Sucesso.`);
            } else {
                response = await api.post(`/saida`, newSaida);
                message.success(`Saida Criada com sucesso`);
            }
            await getSaidas();
            resetSaida();
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function excluirSaida(id: number) {
        try {
            let response: any = await api.delete(`/saida/${id}`);
            getSaidas();

            message.success(`Saida Excluida com Sucesso.`);
        } catch (error: any) {
            message.error(String(error?.response?.data?.message));
        }
    }

    async function changePage(page: any) {
        setPage(page);
        getSaidas();
    }

    async function modificaData(campo: string, evento: any) {
        return campo == "de"
            ? setDe(moment(evento.target.value))
            : setAte(moment(evento.target.value));
    }

    return (
        <Container>
            <HeaderPonto>
                <h1 className="titlePonto">Relatório de Saídas</h1>
                <button
                    style={{
                        margin: "0px",
                        width: "100px",
                        letterSpacing: "1px",
                        verticalAlign: "middle",
                    }}
                    className="btn btn-primary"
                    onClick={() => editarSaida(null)}
                >
                    Adicionar
                    <i className="fa-solid fa-plus"></i>
                </button>
            </HeaderPonto>

            <SectionFilterPonto>
                <InputDate
                    mask="date"
                    label="Data Inicial"
                    name="Data Inicial"
                    onChange={(e) => modificaData("de", e)}
                    value={de.format("DD-MM-YYYY")}
                    maxLength={10}
                    handleOnClearDate={() => console.log("alala")}
                />

                <InputDate
                    mask="date"
                    label="Data Final"
                    name="Data Final"
                    onChange={(e) => modificaData("ate", e)}
                    value={ate.format("DD-MM-YYYY")}
                    maxLength={10}
                    handleOnClearDate={() => console.log("alala")}
                />

                <button
                    style={{
                        margin: "0px",
                        width: "100px",
                        letterSpacing: "1px",
                    }}
                    className="btn btn-secondary"
                    onClick={(e: any) => getSaidas()}
                >
                    Filtrar
                    <IconFilter />
                </button>
            </SectionFilterPonto>

            <SectionTablePonto>
                <table className="default">
                    <thead>
                        <tr>
                            <th>Conta</th>
                            <th>Colaborador</th>
                            <th>Despesa</th>
                            {saidas &&
                                saidas.meses &&
                                Object.keys(saidas.meses).map(
                                    (chave, index) => <th>{chave}</th>
                                )}
                            <th>TOTAL</th>
                        </tr>
                    </thead>

                    <tbody>
                        {saidas &&
                            saidas.projetos &&
                            saidas.projetos.length > 0 &&
                            saidas.projetos.map((row: any, key: any) => (
                                <tr key={""}>
                                    <td>{row?.conta}</td>
                                    <td>{row?.colaborador}</td>
                                    <td>{row?.despesa}</td>

                                    {row &&
                                        row.saidas &&
                                        Object.keys(row.saidas).map(
                                            (
                                                rowEntrada: any,
                                                keyEntrada: any
                                            ) => (
                                                <td>
                                                    {row.saidas[rowEntrada] &&
                                                        row.saidas[rowEntrada]
                                                            .saidas.length >
                                                            0 &&
                                                        row.saidas[
                                                            rowEntrada
                                                        ].saidas.map(
                                                            (
                                                                row2: any,
                                                                key2: any
                                                            ) => (
                                                                <>
                                                                    <Value
                                                                        key={
                                                                            key2
                                                                        }
                                                                    >
                                                                        {parseFloat(
                                                                            row2.valor
                                                                        ).toLocaleString(
                                                                            "pt-BR",
                                                                            {
                                                                                style: "currency",
                                                                                currency:
                                                                                    "BRL",
                                                                            }
                                                                        )}
                                                                        <CommentBoxSaida
                                                                            Status={
                                                                                row2.statusPagamento
                                                                            }
                                                                            FormaPagamento={
                                                                                row2.tipoPagamento
                                                                            }
                                                                            dataPagamento={
                                                                                row2.dataPagamento
                                                                            }
                                                                            saidaId={
                                                                                row2.id
                                                                            }
                                                                            valor={
                                                                                row2.valor
                                                                            }

                                                                            despesa={
                                                                                row2.despesa
                                                                            }
                                                                            colaborador={
                                                                                row2.colaborador
                                                                            }
                                                                            editarSaida={() =>
                                                                                editarSaida(
                                                                                    row2.id
                                                                                )
                                                                            }
                                                                        />
                                                                    </Value>
                                                                    <br />
                                                                </>
                                                            )
                                                        )}
                                                </td>
                                            )
                                        )}
                                    <td>
                                        {parseFloat(
                                            row.total.valor
                                        ).toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        })}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={3}>TOTAL PAGO</td>
                            {saidas &&
                                saidas.foot &&
                                Object.keys(saidas.foot).map(
                                    (rowFoot: any, keyFoot: any) => (
                                        <td style={{ background: "#9fe3bd" }}>
                                            {parseFloat(
                                                saidas.foot[rowFoot].totalPago
                                            ).toLocaleString("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            })}
                                        </td>
                                    )
                                )}
                            <td style={{ background: "#9fe3bd" }}>
                                {parseFloat(
                                    saidas.totalGeralPago
                                ).toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3}>TOTAL</td>

                            {saidas &&
                                saidas.foot &&
                                Object.keys(saidas.foot).map(
                                    (rowFoot: any, keyFoot: any) => (
                                        <td style={{ background: "#c5e9d5" }}>
                                            {parseFloat(
                                                saidas.foot[rowFoot].total
                                            ).toLocaleString("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            })}
                                        </td>
                                    )
                                )}
                            <td style={{ background: "#c5e9d5" }}>
                                {parseFloat(saidas.totalGeral).toLocaleString(
                                    "pt-BR",
                                    {
                                        style: "currency",
                                        currency: "BRL",
                                    }
                                )}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </SectionTablePonto>

            <ModalDefault
                id="modalDefault"
                onClose={() => resetSaida()}
                visible={modal}
            >
                <ContainerModal>
                    <SectionModal>
                        <form onSubmit={saveSaida}>
                            <h1>Editar / Adicionar - Saida</h1>
                            <div
                                className="field"
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <div
                                    className="field"
                                    style={{
                                        width: "50%",
                                        flexDirection: "column",
                                    }}
                                >
                                    <h4>Data</h4>
                                    <div className="input">
                                        <InputDate
                                            mask="date"
                                            label=""
                                            name="data"
                                            onChange={(e) =>
                                                handleOnChangeNewSaida(
                                                    "data",
                                                    e.target.value
                                                )
                                            }
                                            value={newSaida.data}
                                            maxLength={10}
                                            handleOnClearDate={() =>
                                                handleOnChangeNewSaida
                                            }
                                        />
                                    </div>
                                </div>
                                <div
                                    className="field"
                                    style={{
                                        width: "50%",
                                        flexDirection: "column",
                                    }}
                                >
                                    <h4>Data de Pagamento</h4>
                                    <div className="input">
                                        <InputDate
                                            mask="date"
                                            label=""
                                            name="data"
                                            onChange={(e) =>
                                                handleOnChangeNewSaida(
                                                    "dataPagamento",
                                                    e.target.value
                                                )
                                            }
                                            value={newSaida.dataPagamento}
                                            maxLength={10}
                                            handleOnClearDate={() =>
                                                handleOnChangeNewSaida
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="field">
                                <h4>Valor</h4>
                                <div className="input">
                                    <Input
                                        type="text"
                                        name="valor"
                                        mask="money"
                                        value={newSaida?.valor}
                                        onChange={handleOnChangeNewSaida}
                                    />
                                </div>
                            </div>
                            <div className="field">
                                <h4>Colaborador</h4>
                                <div className="input">
                                    <Select
                                        name="colaboradorId"
                                        onChange={handleOnChangeNewSaida}
                                        value={
                                            newSaida?.colaboradorId
                                                ? newSaida?.colaboradorId
                                                : ""
                                        }
                                    >
                                        <option value="">
                                            Selecione aqui...
                                        </option>
                                        {colaboradores &&
                                            colaboradores.length > 0 &&
                                            colaboradores.map(
                                                (row: any, key: any) => (
                                                    <option
                                                        key={key}
                                                        value={
                                                            row.colaboradorId
                                                        }
                                                    >
                                                        {row.nome}
                                                    </option>
                                                )
                                            )}
                                    </Select>
                                </div>
                            </div>

                            <div className="field">
                                <h4>Despesa</h4>
                                <div className="input">
                                    <Select
                                        name="despesaId"
                                        onChange={handleOnChangeNewSaida}
                                        value={
                                            newSaida?.despesaId
                                                ? newSaida?.despesaId
                                                : ""
                                        }
                                    >
                                        <option value="">
                                            Selecione aqui...
                                        </option>
                                        {despesas &&
                                            despesas.length > 0 &&
                                            despesas.map(
                                                (row: any, key: any) => (
                                                    <option
                                                        key={key}
                                                        value={row.despesaId}
                                                    >
                                                        {row.nome}
                                                    </option>
                                                )
                                            )}
                                    </Select>
                                </div>
                            </div>

                            <div className="field">
                                <h4>Conta</h4>
                                <div className="input">
                                    <Select
                                        name="contaId"
                                        onChange={handleOnChangeNewSaida}
                                        value={
                                            newSaida?.contaId
                                                ? newSaida?.contaId
                                                : ""
                                        }
                                    >
                                        <option value="">
                                            Selecione aqui...
                                        </option>
                                        {contas &&
                                            contas.length > 0 &&
                                            contas.map((row: any, key: any) => (
                                                <option
                                                    key={key}
                                                    value={row.contaId}
                                                >
                                                    {row.nome}
                                                </option>
                                            ))}
                                    </Select>
                                </div>
                            </div>

                            <div className="field">
                                <h4>Status Pagamento</h4>
                                <div className="input">
                                    <Select
                                        name="statusPagamento"
                                        onChange={handleOnChangeNewSaida}
                                        value={
                                            newSaida?.statusPagamento
                                                ? newSaida?.statusPagamento
                                                : ""
                                        }
                                    >
                                        <option value="">
                                            Selecione aqui...
                                        </option>
                                        <option value="pendente">
                                            PENDENTE
                                        </option>
                                        <option value="pago">PAGO</option>
                                        <option value="atraso">
                                            EM ATRASO
                                        </option>
                                    </Select>
                                </div>
                            </div>

                            <div className="field">
                                <h4>Arquivo</h4>
                                <div className="input">
                                    <div>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                        />
                                        <button
                                            style={{ textAlign: "center" }}
                                            type="button"
                                            className="btn btn-success-outline"
                                            onClick={handleChooseFile}
                                        >
                                            Escolher Arquivo
                                        </button>
                                        {selectedFile && newSaida?.arquivo && (
                                            <div>
                                                <p>
                                                    Arquivo selecionado:{" "}
                                                    {selectedFile?.name}
                                                </p>
                                                <button
                                                    className="btn btn-success"
                                                    onClick={handleRemoveFile}
                                                >
                                                    Remover
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="actions">
                                <button
                                    type="submit"
                                    onClick={() => setModal(!modal)}
                                    className="btn btn-success"
                                >
                                    Salvar
                                </button>
                                <button
                                    type="button"
                                    onClick={() => resetSaida()}
                                    className="btn btn-danger"
                                >
                                    Voltar
                                </button>
                            </div>
                        </form>
                    </SectionModal>
                    <button
                        className="buttonClosePreview"
                        onClick={() => resetSaida()}
                    >
                        <IconRemove width="22px" height="22px" />
                        Fechar modal
                    </button>
                </ContainerModal>
            </ModalDefault>
        </Container>
    );
}
